import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useAuth } from '../App';

const ThemeToggle = () => {
  const { theme, setTheme } = useAuth();
  const isDark = theme === 'dark' || (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);

  const toggleTheme = () => {
    setTheme(isDark ? 'light' : 'dark');
  };

  return (
    <button
      onClick={toggleTheme}
      className="relative w-14 h-7 bg-muted hover:bg-muted/80 rounded-full transition-all duration-300 border-2 border-border"
      aria-label="Toggle theme"
      title={`Switch to ${isDark ? 'light' : 'dark'} mode`}
    >
      <div
        className={`absolute top-0.5 ${
          isDark ? 'right-0.5' : 'left-0.5'
        } w-5 h-5 bg-primary rounded-full transition-all duration-300 flex items-center justify-center shadow-md`}
      >
        {isDark ? (
          <Moon className="w-3 h-3 text-primary-foreground" />
        ) : (
          <Sun className="w-3 h-3 text-primary-foreground" />
        )}
      </div>
    </button>
  );
};

export default ThemeToggle;
